import React, {useCallback, useEffect, useRef, useState} from "react";
import {useNavigate} from "react-router-dom";
import {GenericModal} from "../../common/genericModal/GenericModal";
import {lessonPlayerStore} from "../../../redux/lesson/LessonPlayerStore";
import {appRoutePaths} from "../../../config/config";
import s from "./LessonPermissionDeniedModal.module.scss";

const COUNTDOWN_DURATION_MS = 10000;
const TICK_INTERVAL_MS = 50;

export function LessonPermissionDeniedModal() {
  const navigate = useNavigate();
  const [remainingMs, setRemainingMs] = useState(COUNTDOWN_DURATION_MS);
  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const redirectToDashboard = useCallback(() => {
    lessonPlayerStore.setShowPermissionDeniedModal(false);
    navigate(appRoutePaths.dashboardPage);
  }, [navigate]);

  useEffect(() => {
    timerRef.current = setInterval(() => {
      setRemainingMs((prev) => {
        const next = prev - TICK_INTERVAL_MS;
        if (next <= 0) {
          if (timerRef.current) {
            clearInterval(timerRef.current);
          }
          return 0;
        }
        return next;
      });
    }, TICK_INTERVAL_MS);

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (remainingMs <= 0) {
      redirectToDashboard();
    }
  }, [remainingMs, redirectToDashboard]);

  const progressPercent = (remainingMs / COUNTDOWN_DURATION_MS) * 100;

  return (
    <GenericModal
      canShow={true}
      title="You're no longer a Member"
      onClose={redirectToDashboard}
    >
      <div className={s.body}>
        <p className={s.message}>
          Your membership has expired. You no longer have access to Bootcamp, Songs, and most Courses.
          <br />
          Redirecting to your dashboard…
        </p>
        <div className={s.progressBarTrack}>
          <div
            className={s.progressBarFill}
            style={{
              width: `${progressPercent}%`,
              transitionDuration: `${TICK_INTERVAL_MS}ms`,
            }}
          />
        </div>
      </div>
    </GenericModal>
  );
}
